import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

// Langue courante sur toutes les requêtes GET (traductions produits backend)
api.interceptors.request.use((config) => {
  if ((config.method || "get") === "get") {
    config.params = { ...(config.params || {}), lang: document.documentElement.lang || "fr" };
  }
  return config;
});

api.interceptors.response.use(null, async (error) => {
  const original = error.config;
  if (
    error.response?.status === 401 &&
    original && !original._retried &&
    !String(original.url || "").includes("/auth/")
  ) {
    original._retried = true;
    try {
      await axios.post(`${API_BASE}/auth/refresh`, {}, { withCredentials: true });
      return api(original);
    } catch {
      return Promise.reject(error);
    }
  }
  return Promise.reject(error);
});

export const LANG_LOCALES = { fr: "fr-FR", en: "en-US", it: "it-IT", ar: "ar-DZ" };

const loc = () => LANG_LOCALES[document.documentElement.lang] || "fr-FR";

export const fmtXOF = (n) =>
  `${Number(n).toLocaleString(loc())} FCFA`;

export const fmtEUR = (n) =>
  `≈ ${Math.round(n / 655.957).toLocaleString(loc())} €`;
